export default "__VITE_ASSET__rOFMvQx6__"